// File: /src/components/ClientsList.js

import React from 'react';
import ClientCard from './ClientCard';
import '../styles/GridClients.css';

const ClientsList = ({
	clients,
	selectedClients,
	cardColors,
	toggleSelectClient,
	handleColorChange,
	openClientModal,
	isShowingArchived,
}) => {
	if (clients.length === 0) {
		return (
			<div className="no-clients-message">
				<p>
					{isShowingArchived 
						? "Nenhum cliente arquivado."
						: "Você ainda não possui nenhum cliente cadastrado. Clique no botão \"Adicionar Cliente\" para começar."}
				</p>
			</div>
		);
	}

	return (
		<div className="list-view">
			{clients.map((client) => (
				<ClientCard
					key={client.id}
					client={client}
					borderColor={cardColors[client.id] || 'transparent'}
					isSelected={selectedClients.includes(client.id)}
					onToggleSelect={() => toggleSelectClient(client.id)}
					onColorChange={handleColorChange}
					onClick={() => openClientModal(client)}
					viewMode="list"
				/>
			))}
		</div>
	);
};

export default ClientsList;
